import { render, staticRenderFns } from "./CabeceraClubs.vue?vue&type=template&id=fd6c3ffe"
import script from "./CabeceraClubs.vue?vue&type=script&lang=js"
export * from "./CabeceraClubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports